import React from "react"
import wp from "../images/phone-icon.svg"
import styled from "styled-components"

const WpWrapper = styled.div`
.whats-app {
  position: fixed;
  width: 40px;
  height: 40px;
  bottom: 25px;
  text-align: center;
  right: 10px;
  z-index: 100;
}
.my-float {
  margin-top: 10px;
}
@media screen and (min-width: ${props => props.theme.sizes.mobile}) {
    display: none;
  }
`



const Whatsapp = () => (
    <WpWrapper>
        <a
            className="whats-app"
            href="tel:905416317013"
            rel="noopener noreferrer"
            target="_blank"
        >
            <div className="blob green">
                <img
                    className="fa fa-whatsapp my-float"
                    title="Konya İnşaat, Konya Yapı Dekorasyon Whatsapp İletişim Hattı"
                    src={wp}
                    alt="Konya ev tadilatı, konya ofis tadilatı, konya boya badana, konya anahtar teslim inşaat, konya villa tadilatı, konya banyo tadilatı, konya asma tavan, konya alçıpan asma tavan, konya inşaat işleri, konya mutfak tadilatı, konya metal asma tavan, konya alçıpan bölme duvar, konya yıkım işleri, konya duvar kağıtları"
                />
            </div>
        </a>
    </WpWrapper>
)

export default Whatsapp